// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetNewbuildingPromoSnippetForMapRequest,
  TGetNewbuildingPromoSnippetForMapModel,
  IMappers,
  TGetNewbuildingPromoSnippetForMapResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingPromoSnippetForMapResponse } from '../../entities/response/GetNewbuildingPromoSnippetForMapResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingPromoSnippetForMapModel(
  parameters: IGetNewbuildingPromoSnippetForMapRequest,
): TGetNewbuildingPromoSnippetForMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-content-promotion',
    pathApi: '/v1/get-newbuilding-promo-snippet-for-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetNewbuildingPromoSnippetForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingPromoSnippetForMapRequest;
}

export async function fetchGetNewbuildingPromoSnippetForMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingPromoSnippetForMapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingPromoSnippetForMapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingPromoSnippetForMapModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingPromoSnippetForMapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingPromoSnippetForMapResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingPromoSnippetForMapResponse>;
}
